(() => {
  if (window.matchMedia('(min-width: 768px)').matches) {
    const firstDetail = document.querySelector('.home-trust__details > details:first-of-type');
    if (firstDetail) firstDetail.open = true;
  }
  function revealTrial(focus) {
    const target = document.getElementById('home-comfort-trial');
    if (!target) return;
    if (window.matchMedia('(min-width: 768px)').matches) target.open = true;
    target.style.scrollMarginTop = `${Math.ceil(document.querySelector('header')?.offsetHeight || 110) + 20}px`;
    if (focus) target.querySelector('summary')?.focus({preventScroll:true});
    requestAnimationFrame(() => target.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-comfort-trial-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
    if (!document.getElementById('home-comfort-trial')) return;
    event.preventDefault();
    history.pushState(null, '', '#home-comfort-trial');
    revealTrial(true);
  });
  window.addEventListener('hashchange', () => {if(location.hash==='#home-comfort-trial')revealTrial(false);});
  if (location.hash === '#home-comfort-trial') revealTrial(false);
})();
